import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { TokenService } from 'services/token/token.service';
import { EntryService } from 'services/entry/entry.service';
import { MixpanelService } from 'services/mixpanel/mixpanel.service';
import { MIXPANEL_EVENTS } from 'constants/mixpanel-events.constants';
import { email } from '@certemy/common';

@Component({
  selector: 'cm-forgot-password',
  styleUrls: ['./forgotpw.component.scss'],
  templateUrl: './forgotpw.component.html',
})
export class ForgotPWComponent implements OnInit {
  form: UntypedFormGroup;
  message = '';

  constructor(
    private tokenService: TokenService,
    private entryService: EntryService,
    private router: Router,
    private mixpanel: MixpanelService,
  ) {
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl('', Validators.compose([Validators.required, email])),
    });
  }

  ngOnInit() {
    this.mixpanel.track(MIXPANEL_EVENTS.FORGOT_PASSWORD_FORM_VIEW);
  }

  onSubmit(values: any): void {
    this.message = '';
    if (this.form.valid) {
      this.tokenService.resetUserPassword(values).subscribe(
        data => {
          if (data.code_name === 'ERROR') {
            this.message = 'Email is incorrect';
          } else {
            this.entryService.setMessageType({ msg: 'password', email: values.email });
            this.router.navigate(['/entry/message']);
          }
        },
        () => {
          this.message = 'Email is incorrect';
        },
      );
    } else {
      if (this.form.controls['email'].errors['required']) {
        this.message = 'Please fill out email';
      } else if (this.form.controls['email'].errors['email']) {
        this.message = 'Please enter the valid email';
      }
    }
  }
}
